import React from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { Loader2, X, RotateCw, Crop, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';
import { useLanguage } from '../../contexts/LanguageContext';

export const CropStep = ({
  imagePreview, identifying, crop, setCrop, setCompletedCrop,
  rotation, imageRef, batchMode, handleSkipPhoto, onRemovePhoto, onCancel,
  handleRotate, handleDoneCropping
}) => {
  const { t } = useLanguage();
  return (
    <div className="space-y-4">
      {identifying && (
        <div className="absolute inset-0 z-10 flex items-center justify-center rounded-lg" style={{ backgroundColor: 'rgba(255,255,255,0.85)' }}>
          <div className="text-center">
            <Loader2 className="w-10 h-10 mx-auto mb-3 animate-spin" style={{ color: 'hsl(21, 70%, 57%)' }} />
            <p className="text-base font-medium" style={{ color: 'hsl(143, 28%, 25%)' }}>{t('identifyingPlant')}</p>
          </div>
        </div>
      )}
      <div className="relative rounded-xl overflow-hidden" style={{ backgroundColor: 'hsl(82, 55%, 95%)' }}>
        <ReactCrop crop={crop} onChange={(c) => setCrop(c)} onComplete={(c) => setCompletedCrop(c)}>
          <img ref={imageRef} src={imagePreview} alt="Preview"
            style={{ transform: `rotate(${rotation}deg)`, maxHeight: '60vh' }} className="max-w-full" />
        </ReactCrop>
      </div>
      <div className="flex items-start gap-2 rounded-lg px-3 py-2" style={{ backgroundColor: 'hsl(143, 28%, 94%)', border: '1px solid hsl(143, 28%, 85%)' }} data-testid="crop-instructions">
        <Crop className="w-4 h-4 flex-shrink-0 mt-0.5" style={{ color: 'hsl(143, 28%, 35%)' }} />
        <p className="text-xs leading-relaxed" style={{ color: 'hsl(143, 28%, 25%)' }}>
          <strong>{t('cropInstructions')}</strong> {t('cropDesc')}
        </p>
      </div>
      <div className="flex gap-2 flex-wrap">
        <Button
          onClick={() => {
            if (batchMode) { handleSkipPhoto(); }
            else { onCancel(); }
          }}
          variant="outline"
          style={{ borderColor: 'hsl(143, 28%, 85%)', color: 'hsl(143, 28%, 25%)' }}
          data-testid={batchMode ? "skip-photo-button" : "crop-cancel-button"}
          disabled={identifying}
        >
          <X className="w-4 h-4 mr-1" />
          {batchMode ? t('skip') : t('cancel')}
        </Button>
        <Button onClick={handleRotate} variant="outline" data-testid="rotate-button" disabled={identifying}>
          <RotateCw className="w-4 h-4 mr-1" />
          {t('rotate')}
        </Button>
        <Button
          onClick={handleDoneCropping}
          disabled={identifying}
          className="flex-1"
          style={{ backgroundColor: 'hsl(143, 28%, 25%)', color: 'white' }}
          data-testid="done-cropping-button"
        >
          <Crop className="w-4 h-4 mr-2" />
          {t('doneCropping')}
        </Button>
      </div>
      {batchMode && onRemovePhoto && (
        <div className="flex justify-center">
          <button
            onClick={onRemovePhoto}
            disabled={identifying}
            className="inline-flex items-center gap-1.5 text-sm font-medium underline disabled:opacity-40"
            style={{ color: 'hsl(0, 60%, 45%)' }}
            data-testid="remove-photo-button"
          >
            <Trash2 className="w-3.5 h-3.5" />
            {t('removeThisPhoto') || 'Remove this photo'}
          </button>
        </div>
      )}
    </div>
  );
};
